import { DEFAULT_FONT_COLOR } from '@messenger/consts'
import { DEFAULT_FONT_FAMILY, withScriptFallback } from '@messenger/lotus/fonts'
import { countEditorProbeRender } from '@/utils/editor/editorProbe'

const RETIRED_THEME_FONT_FAMILIES = [
  'AG University',
  'Amazone',
  'Aniyah',
  'Big Caslon',
  'Eyeglass',
]

export const applyDefaultThemeStyles = (props) => {
  countEditorProbeRender('applyDefaultThemeStyles')
  const { editor, tinyMceEvent, selectedTheme, isVerse = false } = props
  const targetElement = tinyMceEvent.target
  const bodyElement = targetElement.bodyElement
  const textBoxValue = bodyElement.innerText ?? ''
  const hasSpan = !!bodyElement.querySelector('span')
  const defaultTextBoxValue = 'New Text Box'
  const isNotVerse = !isVerse
  const textBoxChanged = textBoxValue.trim() !== defaultTextBoxValue
  const hasCustomSpan = hasSpan
  const shouldReturnEarly = isNotVerse && (textBoxChanged || hasCustomSpan)
  if (shouldReturnEarly) return

  try {
    const hasThemeFontFamily = !!selectedTheme?.font
    const hasThemeFontColor = !!selectedTheme?.font_color
    const useThemeFontFamily =
      hasThemeFontFamily &&
      !RETIRED_THEME_FONT_FAMILIES.includes(selectedTheme?.font)

    const resolvedFontColor = hasThemeFontColor
      ? selectedTheme.font_color
      : DEFAULT_FONT_COLOR
    const resolvedFontFamily = useThemeFontFamily
      ? selectedTheme.font
      : DEFAULT_FONT_FAMILY

    if (!isVerse) {
      const bodyContent = targetElement.contentAreaContainer
      editor.selection.select(bodyContent)
    }

    const applyFormatter = () => {
      editor.formatter.apply('forecolor', {
        value: resolvedFontColor,
      })
      editor.formatter.apply('fontname', {
        value: withScriptFallback(resolvedFontFamily),
      })

      if (!isVerse) {
        editor.ui.hide()
        editor.selection.collapse()
        editor.getBody().blur()
      }
    }

    requestAnimationFrame(applyFormatter)
  } catch (error) {
    console.error('Failed to apply theme styles:', error)
  }
}

export default applyDefaultThemeStyles
